export default [
  {
    path: 'accounts/organisations',
    name: 'Organisations',
    component: () => import('@/app/organisation/views/Organisations.vue'),
  },
  {
    path: 'accounts/organisations/new',
    name: 'AddOrganisation',
    component: () => import('@/app/organisation/views/AddOrganisation.vue'),
  },
  {
    path: 'accounts/organisations/:id',
    name: 'OrganisationDetail',
    component: () => import('@/app/organisation/views/OrganisationDetail.vue'),
  },
];
